<template>
  <div class="kontakt-page">
      <h1 v-html="title"></h1>
      <section class="section">
        <div v-if="content" v-html="content"></div>
        <div v-else>
          <p>Hier können die Kontaktdaten gepflegt werden.</p>
        </div>
      </section>
    </div>
</template>

<script>
import { useConfig } from '../composables/useConfig.js';

export default {
  name: "KontaktPage",
  setup() {
    const { config, loadConfig } = useConfig();
    loadConfig();
    return { config };
  },
  computed: {
    title() {
      return this.config?.contactPage?.title || 'Kontakt';
    },
    content() {
      return this.config?.contactPage?.content || null;
    }
  }
};
</script>

<style scoped>
.kontakt-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 1.5rem;
}

.kontakt-page h1 {
  margin-bottom: 1rem;
}

.kontakt-page section {
  margin-bottom: 1.25rem;
}
</style>